module.exports = __webpack_public_path__ + "static/home_02_mobile-8761e676b0dc8bba8adb662c4b28ccc3.webp";